<template>
  <!-- 页面顶部组件  -->
  <div
    class="common-header-wrap"
    :class="{ home: routePath.indexOf('home') > -1 }"
  >
    <div class="common-width clearfix">
      <router-link to="/">
        <img class="logo" src="/static/image/common/logo.png" alt="logo"/>
      </router-link>
      <div class="fr common-navbar mobile-hide">
        <el-menu
          :default-active="activeIndex"
          class="common-navbar-menu"
          mode="horizontal"
        >
          <el-menu-item index="1">
            <router-link
              class="common-navbar-item"
              :class="routePath == '/home' ? 'router-link-active' : ''"
              :to="'/home'"
            >首页
            </router-link
            >
          </el-menu-item>
          <el-menu-item index="3">
            <router-link class="common-navbar-item" :to="'/product'"
            >产品
            </router-link
            >
          </el-menu-item>
          <el-menu-item index="4">
            <router-link class="common-navbar-item" :to="'/case'"
            >案例
            </router-link
            >
          </el-menu-item>
          <el-menu-item index="5">
            <router-link class="common-navbar-item" :to="'/aboutus'"
            >关于我们
            </router-link
            >
          </el-menu-item>
          <el-menu-item index="6">
            <router-link class="common-navbar-item" :to="'/contactus'"
            >联系我们
            </router-link
            >
          </el-menu-item>
          <el-menu-item index="7">
            <div class="info-out">
              <span class="el-icon-message email-icon"></span>
              <span>business@51shanglian.com</span>
              <span class="fgf">|</span>
              <img class="qq-icon" src="/static/icon/qq.png" @click="qqConsult"/>
            </div>
          </el-menu-item>
        </el-menu>
      </div>
      <!-- 手机目录导航 -->
      <el-drawer
        title="目录"
        :visible.sync="showMobileCategory"
        direction="ltr"
        size="284"
        :with-header="false"
        class="mobile-nav-part"
      >
        <div class="fr common-navbar mobile-common-navbar">
          <img class="logo" src="/static/image/common/logo.png" alt="logo"/>
          <div>
            <el-menu
              :default-active="activeIndex"
              mode="vertical"
              :collapse="false"
              class="common-navbar-menu"
            >
              <el-menu-item index="1">
                <router-link
                  class="common-navbar-item"
                  :class="routePath == '/home' ? 'router-link-active' : ''"
                  :to="'/home'"
                >首页
                </router-link
                >
              </el-menu-item>
              <el-menu-item index="3">
                <router-link class="common-navbar-item" :to="'/product'"
                >产品
                </router-link
                >
              </el-menu-item>
              <el-menu-item index="4">
                <router-link class="common-navbar-item" :to="'/case'"
                >案例
                </router-link
                >
              </el-menu-item>
              <el-menu-item index="5">
                <router-link class="common-navbar-item" :to="'/aboutus'"
                >关于我们
                </router-link
                >
              </el-menu-item>
              <el-menu-item index="6">
                <router-link class="common-navbar-item" :to="'/contactus'"
                >联系我们
                </router-link
                >
              </el-menu-item>
            </el-menu>
          </div>
        </div>
      </el-drawer>
    </div>
    <el-button
      class="mobile-category-btn mobile-show"
      @click="showMobileCategory = !showMobileCategory"
    >目录
    </el-button
    >
  </div>
</template>

<script>
export default {
  data () {
    return {
      activeIndex: '1', // navbar 导航栏默认选中index
      routePath: '/home', // 当前页route path，默认为首页
      showMobileCategory: false // 是否显示手机版目录
    }
  },
  components: {},
  methods: {
    /**
     * 获取route path
     **/
    getRoutePath () {
      console.log('路由', this.$route.path)
      this.routePath = this.$route.path === '/' ? '/home' : this.$route.path
      console.log('当前页route path', this.routePath)
      // 判断当前路由为服务页面时，取消自导航内高亮状态
      // if (this.routePath === '/service') {
      //   console.log(1111)
      //   this.activeIndex = '2-8'
      // }
    }
  },
  watch: {
    '$route' (to, from) {
      // 获取route path
      this.getRoutePath()
      this.showMobileCategory = false
    }
  },
  created () {
    // 获取route path
    this.getRoutePath()
  }
}
</script>

<style scoped>
.common-header-wrap {
  width: 100%;
  padding: 0.16rem 0;
  background: #fff;
}

/* .common-header-wrap.home {
  background: transparent;
  position: absolute;
  z-index: 2;
} */
.common-header-wrap .logo {
  float: left;
  display: block;
  height: 0.38rem;
}

.mobile-category-btn {
  display: none;
  position: fixed;
  z-index: 10;
  top: calc(30vh);
  left: 0;
  border-radius: 100%;
  opacity: 0.8;
  height: 70px;
}

.common-header-wrap .mobile-common-navbar .logo {
  float: none;
  margin: 0 auto 20px;
  width: 264px;
}

.common-header-wrap .mobile-common-navbar {
  padding: 20px 10px;
  float: none;
}

.info-out {
  color: #58A9EC;
  line-height: 0.38rem;
}

.header-wrap .email-icon {
  position: relative;
  font-size: 16px;
  top: 2px;
}

.header-wrap .qq-icon {
  position: relative;
  top: 4px;
  cursor: pointer;
}

.header-wrap .fgf {
  position: relative;
  font-size: 18px;
  margin: 0 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue